import request from "@/common/js/request.js";
// import qs from 'qs'
export function login(username, password) {
  const data = {
    username,
    password
  };
  // let dataTemp = qs.stringify(data)
  return request({
    url: "/user/login",
    method: "post",
    params: data
  });
}

export function loginToGetToken(username, password) {
  const data = {
    username,
    password
  };
  return request({
    url: "/api/auth/jwt/token",
    method: "post",
    data
  });
}

export function logout(token) {
  return request({
    url: "/api/auth/jwt/invalid",
    method: "post",
    params: {
      token
    }
  });
}

export function getInfo() {
  return request({
    url: "/user/front/info",
    method: "get"
  });
}

export function getMenus() {
  return request({
    url: "/user/front/menus",
    method: "get"
  });
}
/**
 * 通过用户名获取用户信息
 * @param {*} name
 */
export function getUser(name) {
  const data = Object.assign(
    {},
    {
      username: name
    }
  );
  return request({
    url: "/user/getUserByUsername",
    method: "get",
    params: data
  });
}

// 获取注册验证码
export function fetchRegisterCode(obj) {
  return request({
    url: "/user/getCaptcha",
    method: "get",
    params: obj
  });
}

// 注册用户
export function fetchRegisterUser(obj) {
  return request({
    url: "/user/userRegister",
    method: "post",
    params: obj
  });
}
// 第三方登录
export function fetchthrdlogin(obj) {
  return request({
    url: "/userThirdAuths/weiXinLogin",
    method: "post",
    data: obj
  });
}

// 新增的酒城后台第三方登录
export function jcrcLogin(obj) {
  return request({
    url: "/user/jcrc/login",
    method: "post",
    data: obj
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js